import { useEffect } from 'react';

import { useObservability } from 'helpers/observability';
import Router from 'next/router';

/**
 * Listens for soft navigations (i.e. navigations that don't result in a full page refresh)
 *
 * - Reports the navigation to analytics
 */
export default function NavListener() {
  const { trackJourneyEvent } = useObservability();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (url !== location.pathname + location.search) {
        trackJourneyEvent('platform', 'pageViewEvent', {});
      }
    };

    Router.events.on('routeChangeStart', handleRouteChange);

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      Router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [trackJourneyEvent]);

  return null;
}
